import './App.css';
import Table from './view/tables/Table';

function App() {
  return (
    <div className="App">
      <Table />
    </div>
  );
}

export default App;
